module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/normalize-wheel/index.js
// module id = 173
// module chunks = 1